<script>
export default {
    name: 'BaseTextarea',

    props: {
        value: {
            type: String,
        },
    },

    data () {
        return {
            focused: false,
            uid: undefined
        }
    },

    mounted() {
        const inBrowser = typeof window !== 'undefined'
        if (inBrowser) {
            this.uid = 'textarea' + Math.random()
        }
    },
}
</script>

<template>
    <div class="base-textarea"
      :class="{
        'has-value': value && value.length,
        'focused': focused
      }">
        <label :for="`${uid}`">
            <div class="label-text">
                <slot name="label"/>
            </div>
        </label>
        <div class="textarea-wrapper">
            <div class="before">
                <slot name="before"/>
            </div>
            <textarea
              @focus="focused = true"
              @blur="focused = false"
              :value.prop="value"
              v-on="$listeners"
              :id="`${uid}`"
              v-bind="$attrs"></textarea>
            <div class="after">
                <slot name="after"/>
            </div>
        </div>
    </div>
</template>
<style lang="stylus">
// @import '../assets/css/base.styl'

.base-textarea
    font-size 1.4em
    min-height 3.8em
    display block
    position relative
    border-bottom 2px solid $AkGreyscaleMediumUltGrey
    cursor text

    label
        display block
        cursor text

    .label-text
        transition ease .2s all
        display block
        font-size .8em
        font-weight bold
        color $AkGreyscaleBlack

    .textarea-wrapper
        display flex
        align-items center
        width 100%

        textarea
            flex-grow 1
            flex-shrink 1
            padding .4em
            border 0
            min-width 0
            box-sizing border-box
            color $AkGreyscaleBlack
            font-family inherit
            font-size inherit
            resize vertical

            &::placeholder
                transition color ease 0s
                color transparent

            &:focus
                outline 0

            &::placeholder
                transition color ease .3s .1s
                color var(--AkGreyscaleMediumLtGrey)

    &.focused
        border-color var(--mainColor)

    &.has-errors
        border-color $AkMajorCoral
        .label-text
            color $AkMajorCoral

    &.base-textarea-small
        font-size 1.15em

        .label-text
            font-size .9em
</style>